import { EnvironmentHelper } from "src/classes/EnvironmentHelper";
import { OrganisationConfig } from "src/interfaces/environment";

const CONFIG: OrganisationConfig = {
  NAME: "fixteamdrenthe",
  TITLE: "Fixteam Drenthe",
  API: null,
  WEBSOCKET: null,
  SHOW_HISTORY: true,
  QR_LOGIN: true,
  QR_REFRESH_RATE: 60000,
  QR_CHECK_RATE: 5000,
  MSAL: null,
  SUBFUNCTIONALITIES: ["VIDEO"],
  MAP: null,
};

const CONFIG_DEVELOPMENT: Partial<OrganisationConfig> = {
  TITLE: "Fixteam Drenthe | Development",
  API: "https://dev.api.epf.fixteamdrenthe.nl",
  MSAL: {
    clientId: "e7c625bb-3e5b-48a1-becf-883ebadcad9d",
    authority: "https://drentheepfdev.b2clogin.com/drentheepfdev.onmicrosoft.com/B2C_1_SignupAndSignin",
    knownAuthorities: ["https://drentheepfdev.b2clogin.com"],
  },
};

const CONFIG_TEST: Partial<OrganisationConfig> = {
  TITLE: "Fixteam Drenthe | Test",
};

const CONFIG_STAGING: Partial<OrganisationConfig> = {
  TITLE: "Fixteam Drenthe | Development",
  API: "https://staging.api.epf.fixteamdrenthe.nl",
  MSAL: {
    clientId: "fc0c8573-fe74-4809-99ac-aad548f30ef0",
    authority: "https://drentheepf.b2clogin.com/drentheepf.onmicrosoft.com/B2C_1_Staging_SignupAndSignin",
    knownAuthorities: ["https://drentheepf.b2clogin.com"],
  },
};

const CONFIG_PRODUCTION: Partial<OrganisationConfig> = {
  TITLE: "Fixteam Drenthe",
  API: "https://api.epf.fixteamdrenthe.nl",
  MSAL: {
    clientId: "fc0c8573-fe74-4809-99ac-aad548f30ef0",
    authority: "https://drentheepf.b2clogin.com/drentheepf.onmicrosoft.com/B2C_1_SignupAndSignin",
    knownAuthorities: ["https://drentheepf.b2clogin.com"],
  },
};

export const ORGANISATION = EnvironmentHelper.GetEnvironment({
  CONFIG,
  CONFIG_DEVELOPMENT,
  CONFIG_TEST,
  CONFIG_STAGING,
  CONFIG_PRODUCTION,
});
